"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _listSelect = _interopRequireDefault(require("./list-select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  /**  array of items */
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: _propTypes.string,
    value: _propTypes.string
  })),

  /** list click handler */
  onChangeHandler: _propTypes.func,

  /**  search query string */
  searchQuery: _propTypes.string,

  /**  array of selected items */
  selectedItems: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: _propTypes.string,
    value: _propTypes.string
  })),

  /** selection count callback handler */
  selectionCountHandler: _propTypes.func,

  /** show list of items */
  show: _propTypes.bool
};

var SearchFilter = function SearchFilter(_ref) {
  var items = _ref.items,
      onChangeHandler = _ref.onChangeHandler,
      _ref$selectionCountHa = _ref.selectionCountHandler,
      selectionCountHandler = _ref$selectionCountHa === void 0 ? function () {} : _ref$selectionCountHa,
      _ref$searchQuery = _ref.searchQuery,
      searchQuery = _ref$searchQuery === void 0 ? "" : _ref$searchQuery,
      _ref$selectedItems = _ref.selectedItems,
      selectedItems = _ref$selectedItems === void 0 ? [] : _ref$selectedItems,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? true : _ref$show;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_listSelect["default"], {
    itemClickHandler: onChangeHandler,
    items: items,
    searchQuery: searchQuery,
    selectedItems: selectedItems,
    selectionCountHandler: selectionCountHandler,
    show: show
  }));
};

SearchFilter.propTypes = propTypes;
var _default = SearchFilter;
exports["default"] = _default;